export default __webpack_public_path__ + "static/media/dress.fe586eed.jpg";